module.exports = __webpack_public_path__ + "img/arrow.22551ad9.svg";